/**
 * Global window bootstrap for CU theme scripts.
 * - window.CU.theme — merged from Liquid (see snippets/cu-theme-global.liquid)
 * - window.CU.loadGsap() — loads GSAP once from CDN; sets window.CU.gsap when ready
 * - window.CU.loadScrollTrigger() — loads ScrollTrigger after GSAP; registers the plugin
 */
(function () {
  var GSAP_SRC = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
  var SCROLLTRIGGER_SRC =
    'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
  var gsapLoadPromise = null;
  var scrollTriggerLoadPromise = null;

  window.CU = window.CU || {};
  if (typeof window.CU.theme !== 'object' || window.CU.theme === null) {
    window.CU.theme = {};
  }

  window.CU.loadGsap = function () {
    if (window.gsap) {
      window.CU.gsap = window.gsap;
      return Promise.resolve(window.gsap);
    }
    if (gsapLoadPromise) {
      return gsapLoadPromise;
    }
    gsapLoadPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = GSAP_SRC;
      s.async = true;
      s.onload = function () {
        window.CU.gsap = window.gsap;
        resolve(window.gsap);
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return gsapLoadPromise;
  };

  window.CU.loadScrollTrigger = function () {
    return window.CU.loadGsap().then(function (gsap) {
      if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        return gsap;
      }
      if (scrollTriggerLoadPromise) {
        return scrollTriggerLoadPromise;
      }
      scrollTriggerLoadPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = SCROLLTRIGGER_SRC;
        s.async = true;
        s.onload = function () {
          if (typeof ScrollTrigger !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger);
          }
          resolve(gsap);
        };
        s.onerror = reject;
        document.head.appendChild(s);
      });
      return scrollTriggerLoadPromise;
    });
  };
})();
